import React from 'react'
import { Check } from 'lucide-react'
import { cn } from '../../../utils/classnames'

const CustomCheckbox = ({
  name,
  label,
  checked,
  onChange,
  disabled = false,
  labelClassName = '',
  checkboxClassName = ''
}) => {
  return (
<label className="flex items-center gap-2 cursor-pointer select-none">
  <span
    className={cn(
      'w-5 h-5 flex-shrink-0 flex items-center justify-center border rounded-md border-bluePale bg-white',
      checked && 'bg-tealUltraLight',
      checkboxClassName
    )}
  >
    {checked && <Check className="w-3 h-3 text-tealLight" strokeWidth={3} />}
    <input
      type="checkbox"
      name={name}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className="hidden"
    />
  </span>
  <span className={cn('text-blueDarker text-sm', labelClassName)}>{label}</span>
</label>
  )
}

export default CustomCheckbox
